module.exports = __webpack_public_path__ + "img/mind_skeleton_0.cc5b7cdf.png";